document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('moreDetailsModal');
  const closeButton = modal.querySelector('.modal-close-button');
  const modalTitle = modal.querySelector('.modal-title');
  const modalBody = modal.querySelector('.modal-body');

  function openModal(title, content) {
    modalTitle.innerHTML = title;
    modalBody.innerHTML = content;
    modal.classList.add('open');
    document.body.classList.add('modal-active'); // Disable scrolling
    console.log('Modal opened, modal-active added to body');
  }

  function closeModal() {
    modal.classList.remove('open');
    document.body.classList.remove('modal-active'); // Enable scrolling
    console.log('Modal closed, modal-active removed from body');
  }

  closeButton.addEventListener('click', closeModal);
  modal.addEventListener('click', function(event) {
    if (event.target === modal) {
      closeModal();
    }
  });
  
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && modal.classList.contains('open')) {
      closeModal();
    }
  });

  const moreDetailsButtons = document.querySelectorAll('.modal-button[data-block-id]');
  moreDetailsButtons.forEach(function(button) {
    const blockId = button.getAttribute('data-block-id');
    const titleElement = document.getElementById('moreDetailsTitle-' + blockId);
    const contentElement = document.getElementById('moreDetailsContent-' + blockId);
    if (titleElement && contentElement) {
      const title = titleElement.innerHTML;
      const content = contentElement.innerHTML;
      button.addEventListener('click', function() {
        openModal(title, content);
      });
    }
  });
});
